module.exports = __webpack_public_path__ + "img/wasajon-2.eff03458.png";